import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'

const AdvancedAccountReceivable: React.FC<IAdvancedAccountReceivable> = ({
  onSubmit,
  onClose,
}) => {
  const [windowWidth, setWindowWidth] = useState<number>(0)

  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  useEffect(() => {
    const { innerWidth } = window
    setWindowWidth(innerWidth)
  }, [])

  const form = useForm()

  return (
    <Form
      form={form}
      onSubmit={(values) => onSubmit({ ...values, isDateSelected })}
      classes="gap-x-2 p-2"
    >
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem name="username" classes="lg:col-span-6 col-span-12">
        <InputText small label="Usuario" maxLength={80} isUpperValue={false} />
      </FormItem>

      <FormItem name="name" classes="lg:col-span-6 col-span-12">
        <InputText small label="Nombre" maxLength={80} isUpperValue={false} />
      </FormItem>

      {/* <FormItem name="description" classes="lg:col-span-12 xl:col-span-6">
        <InputText
          small
          label="Descripción"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem> */}

      <div
        className="lg:col-span-6"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="fromDate"
          classes="lg:col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
        >
          <Datepicker
            label="Fecha desde"
            calendarPosition={windowWidth + 50 - windowWidth}
          />
        </FormItem>
      </div>

      <div
        className="lg:col-span-6"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="toDate"
          classes="lg:col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
        >
          <Datepicker
            label="Fecha hasta"
            calendarPosition={windowWidth + 50 - windowWidth}
          />
        </FormItem>
      </div>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedAccountReceivable {
  onSubmit: (values: any) => void
  onClose: () => void
}

export default AdvancedAccountReceivable
